import React from "react";
import NavPanel from "../Common/Nav/NavPanel";
import TutorialTooltip from "./TutorialTooltip";

const CurrentGameMenu = ({game, links}) => {

    const menuLinks = [];

    if(links && Array.isArray(links)){
        const itemIndex = links.findIndex(link => link.url === "/main/tellAFriend");
        if(itemIndex > -1){
            menuLinks.push(links[itemIndex]);
        }
    }

    if (!game || !links || !menuLinks) {
        return null;
    }

    return <TutorialTooltip>
        <NavPanel gameId={game.id} name={game.name}
                     items={menuLinks}
                     itemType="external"
                     isGameDetailMenu
        />
    </TutorialTooltip>;
};

export default CurrentGameMenu